import { render, staticRenderFns } from "./STableProductsLotComp.vue?vue&type=template&id=a1c37faa&"
import script from "./STableProductsLotComp.vue?vue&type=script&lang=js&"
export * from "./STableProductsLotComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports